import React, { FC } from 'react';

import { IconType } from '../icon.type';

const ChartXyaxisLineIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        style={customStyle}
        viewBox="0 0 28 28"
      >
        <g clipPath="url(#clip0_610_368)">
          <path
            d="M4.38477 21.2568C4.38477 21.7139 4.68359 22.0127 5.14062 22.0127H22.7451C23.2197 22.0127 23.6152 21.6436 23.6152 21.1514C23.6152 20.6592 23.2197 20.29 22.7451 20.29H6.35352C6.16895 20.29 6.10742 20.2285 6.10742 20.0439V15.2627L9.83398 13.1006C10.1328 13.3818 10.5283 13.5576 10.9766 13.5576C11.3545 13.5576 11.7148 13.4258 11.9961 13.2061L13.6484 14.6123C13.5869 14.7881 13.5518 14.9814 13.5518 15.1748C13.5518 16.1064 14.2988 16.8535 15.2217 16.8535C16.1445 16.8535 16.9004 16.1064 16.9004 15.1748C16.9004 15.1045 16.8916 15.0254 16.8828 14.9551L20.9082 12.5469C21.1719 12.7314 21.4971 12.8369 21.8398 12.8369C22.7627 12.8369 23.5186 12.0811 23.5186 11.1582C23.5186 10.2354 22.7627 9.47949 21.8398 9.47949C20.917 9.47949 20.1611 10.2354 20.1611 11.1582C20.1611 11.2725 20.1787 11.3867 20.1963 11.4922L16.25 13.8564C15.9688 13.6367 15.6084 13.5049 15.2217 13.5049C14.9492 13.5049 14.6855 13.5664 14.4482 13.6895L12.6289 12.1426C12.6377 12.0547 12.6465 11.9668 12.6465 11.8789C12.6465 10.9561 11.8994 10.2002 10.9766 10.2002C10.0449 10.2002 9.29785 10.9561 9.29785 11.8789C9.29785 11.9053 9.29785 11.9316 9.29785 11.958L6.10742 13.8037V6.22754C6.10742 5.74414 5.73828 5.35742 5.24609 5.35742C4.75391 5.35742 4.38477 5.74414 4.38477 6.22754V21.2568Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_610_368">
            <rect width="28" height="28" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default ChartXyaxisLineIcon;
